/** @flow */
export const SLA_TYPES_WITH_DISABLED_MEASURE = [
  "call-answering",
  "nurse-availability",
  "scheduled-callbacks",
  "web-service-availability",
];
